import { newLogoReachOk64 } from 'reports/base64Images';

import { groupBy } from 'selectors/generic';
import store from 'source/store';
import theme from 'source/theme';
import { sortBy } from 'lodash';
import { shortDate } from 'utils/helperFunctions/dateFormat';

// `flow.steps` and `step.substeps` - both are the steps slice, read by a
// different column.
const stepsByFlow = groupBy('steps', 'flow_id');
const stepsByMasterStep = groupBy('steps', 'master_step_id');

const dataMapping = [
  { id: 'name', name: 'Código Etapa' },
  { id: 'description', name: 'Descrição' }
];

const rowGenerator = (dataMapping, flows) => {
  const rows = [];
  const state = store.getState();
  const stepsOf = stepsByFlow(state);
  const substepsOf = stepsByMasterStep(state);

  flows.forEach(flow => {
    rows.push([{
        text: `${flow.code} - ${flow.name}`,
        colSpan: 2,
        fillColor: theme.palette.primary.light
      }]
    );
    const steps = sortBy(stepsOf[flow.id] || [], n => n.name);
    steps.forEach(step => {
      if (step.master_step_id === null) {
        rows.push(dataMapping.map(field => step[field.id]));
        (substepsOf[step.id] || []).forEach(substep =>
          rows.push(dataMapping.map(field => `.  ${substep[field.id]}`))
        );
      }
    });
  });

  console.log('rows', rows);

  return rows;
};

const dd = (data) => ({
  pageSize: 'A4',
  pageMargins: [ 40, 60, 40, 40 ],

  footer: function (currentPage, pageCount) {
    return {
      text: `${shortDate(new Date())} - ${currentPage.toString()} de ${pageCount}`,
      alignment: 'right',
      relativePosition: { x: -15, y: 20 },
      fontSize: 7
    };
  },
  header: function (currentPage, pageCount, pageSize) {
    return [
      {
        image: newLogoReachOk64,
        width: 50,
        relativePosition: { x: 20, y: 10 }
      }
    ];
  },
  content: [
    {
      style: 'header',
      text: 'R - Fluxogramas e Etapas',
    },
    {
      style: 'tableExample',
      layout: 'lightHorizontalLines',
      table: {
        headerRows: 1,
        widths: ['*', '*'],
        body: [
          dataMapping.map(i => i.name),
          ...rowGenerator(dataMapping, data)
        ]
      }
    }
  ],
  styles: {
    header: {
      color: theme.palette.primary.main,
      fontSize: 16,
      bold: true,
      alignment: 'center',
      marginTop: 15
    },
    tableExample: {
      margin: [0, 15, 0, 0],
      fontSize: 10
    }
  }

});

export default dd;
